// extracted by mini-css-extract-plugin
export default {"formItem":"formItem_formItem__OBXOB","label":"formItem_label__R+YQO"};